/**
 * Helpers to get FPS, MEMORY, MILLISECONDS
 * Taken from
 * @author mrdoob / http://mrdoob.com/
 */

var Stats = function() {

	var beginTime = ( performance || Date ).now(), prevTime = beginTime, frames = 0, fps = 0;

	return {

		begin: function() {

			beginTime = ( performance || Date ).now();

		},

		end: function() {

			frames ++;

			var time = ( performance || Date ).now();
			// msPanel.update( time - beginTime, 200 );

			if ( time > prevTime + 1000 ) {

        // fpsPanel.update( ( frames * 1000 ) / ( time - prevTime ), 100 );
        fps = ( frames * 1000 ) / ( time - prevTime )

				prevTime = time;
				frames = 0;
        // console.log(fps);

				// if ( memPanel ) {

				// 	var memory = performance.memory;
				// 	memPanel.update( memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576 );

				// }

			}

			return time;

		},

		update: function() {

			beginTime = this.end();

    },

    fps: function() {
      return fps;
    }

	};

};

export { Stats as default };
